
function Skeleton() {


    return (

        <div role="status" className="w-full p-4 rounded-sm shadow-sm animate-pulse md:p-6 dark:border-gray-700">
            <div className="flex items-center justify-center h-[210px] md:h-[555px] mb-4 bg-gray-300 rounded-sm dark:bg-gray-700">
            </div>
            <div className="w-full flex justify-between mb-4 mt-16">
                <div className="hidden md:block h-[70px] w-[70px] bg-gray-200 rounded-md dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-full md:w-[50%] mb-2"></div>
                <div className="hidden md:block h-[70px] w-[70px] bg-gray-200 rounded-md dark:bg-gray-700"></div>
            </div>
        </div>

    );
}

export default Skeleton;